import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import SelectBoxAdapter from '../common/SelectBoxAdapter';

const TemplateIssueRootCauseSelectDropdown = ({
  activeIssueRootCausesGroupedDropdownOptions,
  selectedOption,
  valid,
  disabled,
  onChange,
  dropdownMaxWidth
}) => {
  const textNoAvailableRootCause = activeIssueRootCausesGroupedDropdownOptions.length
    ? undefined
    : i18n.t('new.noAvailableRootCauses');

  return (
    <SelectBoxAdapter
      options={activeIssueRootCausesGroupedDropdownOptions}
      selectedOptions={selectedOption}
      labelKey="title"
      valueKey="id"
      dropdownMaxWidth={dropdownMaxWidth}
      valid={valid}
      disabled={disabled}
      onChange={onChange}
      grouped
      searchable
      searchIcon
      searchPlaceholder={i18n.t('new.search')}
      noResultsValue={textNoAvailableRootCause}
      clearable
    />
  );
};

TemplateIssueRootCauseSelectDropdown.displayName = 'TemplateIssueRootCauseSelectDropdown';

TemplateIssueRootCauseSelectDropdown.propTypes = {
  activeIssueRootCausesGroupedDropdownOptions: PropTypes.array.isRequired,
  selectedOption: PropTypes.object,
  valid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  dropdownMaxWidth: PropTypes.number
};

export default TemplateIssueRootCauseSelectDropdown;
